import { useSelector } from "react-redux";
import AnalysisPage from "../analysis/AnalysisPage";
import ComprehensivePage from "../comprehensive/ComprehensivePage";
import ParagraphPage from "../paragraph/ParagraphPage";
import VocabularyPage from "../vocabulary/VocabularyPage";
import SentencePage from "../sentence/SentencePage";
import GrammarPage from "../grammar/GrammarPage";
import MathPage from "../../math/MathPage";

const SectionPage = ({
  setCurrentStep,
  isPreview = false,
  isReview = false,
}) => {
  const { assignment } = useSelector((state) => state.assignment);

  // 지인에듀 수학 학습지(math_type_worksheet 등). 문제 풀이·수학 입력·채점 결과를 한 화면에서 한다
  if (String(assignment.type || "").startsWith("math_")) {
    return <MathPage setCurrentStep={setCurrentStep} isPreview={isPreview} />;
  }
  if (assignment.type === "analysis") {
    return (
      <AnalysisPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (assignment.type === "comprehensive") {
    return (
      <ComprehensivePage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (assignment.type === "paragraph") {
    return (
      <ParagraphPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (assignment.type === "vocabulary") {
    return (
      <VocabularyPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (assignment.type === "sentence") {
    return (
      <SentencePage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (assignment.type === "grammar" || assignment.type === "bank") {
    // 문제뱅크 시험지(bank)도 어법 화면으로 보낸다. 고른 즉시 정오를 보여 주고
    // 해설을 펼치는 흐름이 문법·단어·문해력에 그대로 맞는다.
    return (
      <GrammarPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  }

  return (
    <div>
      <h1>Section Page</h1>
    </div>
  );
};

export default SectionPage;
